<template>
  <div class="base-report report-sales-analyze">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.mode" size="mini" >
          <el-option
            v-for="item in modes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <span class="accum">累計</span>
        <el-switch
          v-model="searchForm.accumulate"
          active-color="#A9DFFA"
          inactive-color="#C1C4C6">
        </el-switch>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          :show-summary="!currentAccumulate"
          height="100%"
          :summary-method="getSummaries">
          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && currentMode === modeType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import $ from 'jquery'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'
import utils from '@/misc/utils.js'

export default {
  name: 'ReportSalesAnalyze',
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  data () {
    const modeType = {
      daily: 1,
      monthly: 2,
    }
    return {
      rounding: null,
      roundingRatio: null,
      ratioStr: null,
      isLoading: false,
      noData: false,
      modeType: {...modeType},
      modes: [{value: modeType.daily, label: '日毎'}, {value: modeType.monthly, label: '月毎'}],
      tableSetting: [
        {label: '年月日', prop: 'date', align: 'center', fixed: true, sortable: true, width: '130px'},
        {label: '売上(税抜)'},
        [
          {label: '当年', prop: 'salesExcludeTaxNow', align: 'right', sortable: true, width: '120px'},
          {label: '前年', prop: 'salesExcludeTaxLast', align: 'right', sortable: true, width: '120px'},
          {label: '前年比', prop: 'salesExcludeTaxPer', align: 'right', sortable: true, width: '100px'},
          {label: '予算', prop: 'budgetNow', align: 'right', sortable: true, width: '120px'},
          {label: '予算比', prop: 'budgetPer', align: 'right', sortable: true, width: '100px'},
        ],
        {label: '客数'},
        [
          {label: '当年', prop: 'personNow', align: 'right', sortable: true, width: '120px'},
          {label: '前年', prop: 'personLast', align: 'right', sortable: true, width: '120px'},
          {label: '前年比', prop: 'personPer', align: 'right', sortable: true, width: '100px'},
          {label: '予算', prop: 'budgetPersonNow', align: 'right', sortable: true, width: '120px'},
          {label: '予算比', prop: 'budgetPersonPer', align: 'right', sortable: true, width: '100px'},
        ],
        {label: '客単価'},
        [
          {label: '当年', prop: 'personSalesNow', align: 'right', sortable: true, width: '120px'},
          {label: '前年', prop: 'personSalesLast', align: 'right', sortable: true, width: '120px'},
          {label: '前年比', prop: 'personSalesPer', align: 'right', sortable: true, width: '100px'},
          {label: '予算', prop: 'budgetSalesNow', align: 'right', sortable: true, width: '120px'},
          {label: '予算比', prop: 'budgetSalesPer', align: 'right', sortable: true, width: '100px'},
        ],
      ],
      searchForm: {
        mode: modeType.daily,
        from_date: null,
        to_date: null,
        accumulate: false,
      },
      currentMode: modeType.daily,
      currentAccumulate: false,
      items: [],
      orgData: [],
      totalData: [],
      csv_filename: '売上分析.csv',
    }
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
    ...mapGetters('report', [
      'roundingFunction',
      'roundingRatioFunction',
      'ratioStrFunction',
    ]),
    screenData () {
      let result = []
      switch (this.currentMode) {
        case this.modeType.daily:
          result.push(...this.updateScreenDate())
          break
        case this.modeType.monthly:
          result.push(...this.updateScreenMonth())
          break
      }

      // update
      for (let data of result) {
        data.salesExcludeTaxPer = utils.divide(data.salesExcludeTaxNow, data.salesExcludeTaxLast)
        data.personPer = utils.divide(data.personNow, data.personLast)
        data.personSalesNow = utils.divide(data.salesExcludeTaxNow, data.personNow)
        data.personSalesLast = utils.divide(data.salesExcludeTaxLast, data.personLast)
        data.personSalesPer = utils.divide(data.personSalesNow, data.personSalesLast)
        data.budgetPer = utils.divide(data.salesExcludeTaxNow, data.budgetNow)
        data.budgetPersonPer = utils.divide(data.personNow, data.budgetPersonNow)
        data.budgetSalesNow = utils.divide(data.budgetNow, data.budgetPersonNow)
        data.budgetSalesLast = utils.divide(data.budgetLast, data.budgetPersonLast)
        data.budgetSalesPer = utils.divide(data.personSalesNow, data.budgetSalesNow)
      }

      // accumulate
      if (this.currentAccumulate) {
        this.accumulator(result)
      }

      // update TimeName
      this.tableSetting[0].label = this.getDateStr()

      return result
    },
  },
  created () {
    this.rounding = this.roundingFunction
    this.roundingRatio = this.roundingRatioFunction
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.tableSetting[0].label = this.getDateStr()
      this.totalData = []
      this.orgData = []
      this.currentMode = this.searchForm.mode
      this.currentAccumulate = this.searchForm.accumulate

      this.$request.reports.salesAnalyzes(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method).then(res => {
        this.items = res.body

        for (let record of this.items.records) {
          this.orgData.push(record)
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    updateScreenDate () {
      return $.extend(true, [], this.orgData)
    },
    updateScreenMonth () {
      let tmpListData = []
      let listId = []
      for (let data of this.orgData) {
        let yearMonth = moment(data.date).format('YYYYMM')
        let recordCur = tmpListData[listId[yearMonth]]
        let record = {}

        record.date = data.date
        record.salesExcludeTaxNow = data.salesExcludeTaxNow
        record.salesExcludeTaxLast = data.salesExcludeTaxLast
        record.personNow = data.personNow
        record.personLast = data.personLast
        record.budgetNow = data.budgetNow
        record.budgetLast = data.budgetLast
        record.budgetPersonNow = data.budgetPersonNow
        record.budgetPersonLast = data.budgetPersonLast

        if (!recordCur) {
          listId[yearMonth] = tmpListData.length
        } else {
          record.salesExcludeTaxNow = record.salesExcludeTaxNow + recordCur.salesExcludeTaxNow
          record.salesExcludeTaxLast = record.salesExcludeTaxLast + recordCur.salesExcludeTaxLast
          record.personNow = record.personNow + recordCur.personNow
          record.personLast = record.personLast + recordCur.personLast
          record.budgetNow = record.budgetNow + recordCur.budgetNow
          record.budgetLast = record.budgetLast + recordCur.budgetLast
          record.budgetPersonNow = record.budgetPersonNow + recordCur.budgetPersonNow
          record.budgetPersonLast = record.budgetPersonLast + recordCur.budgetPersonLast
        }

        tmpListData[listId[yearMonth]] = record
      }

      return tmpListData
    },
    accumulator (data) {
      for (let [index, record] of data.entries()) {
        if (index === 0) {
          continue
        }
        record.salesExcludeTaxNow += data[index - 1].salesExcludeTaxNow
        record.salesExcludeTaxLast += data[index - 1].salesExcludeTaxLast
        record.salesExcludeTaxPer = utils.divide(record.salesExcludeTaxNow, record.salesExcludeTaxLast)
        record.budgetNow += data[index - 1].budgetNow
        record.budgetLast += data[index - 1].budgetLast
        record.budgetPer = utils.divide(record.salesExcludeTaxNow, record.budgetNow)
        record.personNow += data[index - 1].personNow
        record.personLast += data[index - 1].personLast
        record.personPer = utils.divide(record.personNow, record.personLast)
        record.budgetPersonNow += data[index - 1].budgetPersonNow
        record.budgetPersonLast += data[index - 1].budgetPersonLast
        record.budgetPersonPer = utils.divide(record.personNow, record.budgetPersonNow)
        record.personSalesNow = utils.divide(record.salesExcludeTaxNow, record.personNow)
        record.personSalesLast = utils.divide(record.salesExcludeTaxLast, record.personLast)
        record.personSalesPer = utils.divide(record.personSalesNow, record.personSalesLast)
        record.budgetSalesNow = utils.divide(record.budgetNow, record.budgetPersonNow)
        record.budgetSalesLast = utils.divide(record.budgetLast, record.budgetPersonLast)
        record.budgetSalesPer = utils.divide(record.personSalesNow, record.budgetSalesNow)
      }
    },
    getSummaries ({columns, data}) {
      let totalDic = {}
      let personSalesNow
      let personSalesLast
      let budgetSalesNow
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let prop = columns[index].property
        let reducer = function (a, b) {
          let valb = parseFloat(b[prop]) || 0
          return a + valb
        }
        let values = data.reduce(reducer, 0)
        totalDic[prop] = values

        switch (prop) {
          case 'salesExcludeTaxPer':
            values = utils.divide(totalDic.salesExcludeTaxNow, totalDic.salesExcludeTaxLast)
            break
          case 'personPer':
            values = utils.divide(totalDic.personNow, totalDic.personLast)
            break
          case 'personSalesNow':
            values = utils.divide(totalDic.salesExcludeTaxNow, totalDic.personNow)
            personSalesNow = values
            break
          case 'personSalesLast':
            values = utils.divide(totalDic.salesExcludeTaxLast, totalDic.personLast)
            personSalesLast = values
            break
          case 'personSalesPer':
            values = utils.divide(personSalesNow, personSalesLast)
            break
          case 'budgetPer':
            values = utils.divide(totalDic.salesExcludeTaxNow, totalDic.budgetNow)
            break
          case 'budgetPersonPer':
            values = utils.divide(totalDic.personNow, totalDic.budgetPersonNow)
            break
          case 'budgetSalesNow':
            values = utils.divide(totalDic.budgetNow, totalDic.budgetPersonNow)
            budgetSalesNow = values
            break
          case 'budgetSalesLast':
            values = utils.divide(totalDic.budgetLast, totalDic.budgetPersonLast)
            break
          case 'budgetSalesPer':
            values = utils.divide(personSalesNow, budgetSalesNow)
            break
        }
        this.totalData[index] = this.formatData(prop, values)
      })
      return this.totalData
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key], record['party']))
        }
        data.push(tmp)
      }

      let totalData = this.totalData
      if (this.currentAccumulate) {
        totalData = null
      }
      downloadCSV(this.csv_filename, header, data, totalData)
    },
    date (value, isCsvData = false) {
      let result = '-'
      let date = moment(value)
      switch (this.currentMode) {
        case this.modeType.daily:
          result = date.locale('ja').format('YYYY/M/D')
          if (!isCsvData) {
            result = result + '(' + moment(value).locale('ja').format('ddd') + ')'
          }
          break
        case this.modeType.monthly:
          result = date.format('YYYY年MM月')
          break
      }
      return result
    },
    getDateStr () {
      switch (this.currentMode) {
        case this.modeType.daily:
          return '年月日'
        case this.modeType.monthly:
          return '年月'
      }
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key], row['party'])
    },
    formatData (key, value) {
      let result = !isNaN(value) ? value : 0

      switch (key) {
        case 'date':
          return this.date(value)
        case 'salesExcludeTaxNow':
          return addFigure(this.rounding(value))
        case 'salesExcludeTaxLast':
          return addFigure(this.rounding(value))
        case 'salesExcludeTaxPer':
          return this.ratioStr(value)
        case 'budgetNow':
          return addFigure(this.rounding(value))
        case 'budgetPer':
          return this.ratioStr(value)
        case 'personNow':
          return addFigure(this.rounding(value))
        case 'personLast':
          return addFigure(this.rounding(value))
        case 'personPer':
          return this.ratioStr(value)
        case 'budgetPersonNow':
          return addFigure(this.rounding(value))
        case 'budgetPersonPer':
          return this.ratioStr(value)
        case 'personSalesNow':
          return addFigure(this.rounding(value))
        case 'personSalesLast':
          return addFigure(this.rounding(value))
        case 'personSalesPer':
          return this.ratioStr(value)
        case 'budgetSalesNow':
          return addFigure(this.rounding(value))
        case 'budgetSalesPer':
          return this.ratioStr(value)
        default:
          break
      }
      return result
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
.accum
  color: #606266
  vertical-align: middle
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesAnalyze.vue